module.exports = __webpack_public_path__ + "img/3000443.png";